<script lang="ts">
  // i18n инициализируется в hooks.client.ts ДО первого рендера —
  // здесь ничего не вызываем (onMount было бы поздно: страница
  // форматирует $_() при первом рендере → белый экран).
  import '../app.css'
  import { onMount } from 'svelte'
  import Sidebar from '$components/Sidebar.svelte'
  import BottomNav from '$components/BottomNav.svelte'
  import Toaster from '$components/Toaster.svelte'
  import GlobalSearch from '$components/GlobalSearch.svelte'
  import { initTheme } from '$stores/theme'
  import { sidebarCollapsed } from '$stores/sidebar'

  onMount(() => {
    initTheme()
  })
</script>

<a href="#main-content" class="skip-link">Skip to content</a>

<div class="app-shell" class:collapsed={$sidebarCollapsed}>
  <Sidebar />
  <main id="main-content" class="main">
    <slot />
  </main>
  <BottomNav />
  <Toaster />
  <GlobalSearch />
</div>

<style>
  .main {
    min-height: 100vh;
    padding-bottom: calc(var(--bottom-nav-height) + env(safe-area-inset-bottom));
    transition: margin-left var(--transition-normal);
  }

  @media (min-width: 768px) {
    .main {
      margin-left: 64px;
      padding-bottom: 0;
    }
  }

  @media (min-width: 1024px) {
    .main {
      margin-left: var(--sidebar-width);
    }

    .app-shell.collapsed .main {
      margin-left: var(--sidebar-width-collapsed);
    }
  }

  .skip-link {
    position: absolute;
    top: -40px;
    left: 0;
    background: var(--color-accent);
    color: white;
    padding: var(--space-2) var(--space-4);
    border-radius: var(--radius-md);
    z-index: 9999;
    transition: top 100ms ease-out;
  }

  .skip-link:focus {
    top: 0;
  }
</style>
